var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.74,
    height: 12.987,
    viewBox: "0 0 9.74 12.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "receipt",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M10.035,0H5.706A2.709,2.709,0,0,0,3,2.706v9.74a.541.541,0,0,0,.846.446l1.14-.779,1.14.779a.541.541,0,0,0,.611,0l1.136-.779,1.136.779a.541.541,0,0,0,.612,0l1.136-.778,1.136.778a.541.541,0,0,0,.846-.446V2.706A2.709,2.709,0,0,0,10.035,0Zm1.623,11.418-.6-.407a.541.541,0,0,0-.613,0l-1.136.779-1.136-.779a.541.541,0,0,0-.612,0l-1.136.779-1.136-.779a.541.541,0,0,0-.611,0l-.6.407V2.706A1.623,1.623,0,0,1,5.706,1.082h4.329a1.623,1.623,0,0,1,1.623,1.623Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1341",
    "data-name": "Rectangle 1341",
    width: 5.117,
    height: 0.853,
    rx: 0.426,
    transform: "translate(5.559 4.264)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1342",
    "data-name": "Rectangle 1342",
    width: 4.264,
    height: 0.853,
    rx: 0.426,
    transform: "translate(5.559 6.823)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.fc57a40cd76451bd856e35f800b0cc86.svg";
export { ForwardRef as ReactComponent };